"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEscape = void 0;
const react_1 = require("react");
const useEscape = (callback) => {
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                callback();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [callback]);
};
exports.useEscape = useEscape;
